import handleTagArchive from './handle-tag-archive'
import mountEditForm from './mount-edit-form'

export default (): void => {
  handleTagArchive()
  mountEditForm()
}
